<template>
  <v-alert
    text
    color="primary"
  >
    <h3 class="text-h5">
      {{ $t('booking.relocateReservations.title', locale) }}
    </h3>
    <!--div>Maecenas nec odio et ante tincidunt tempus. Sed mollis, eros et ultrices tempus, mauris ipsum aliquam libero, non adipiscing dolor urna a orci. Proin viverra, ligula sit amet ultrices semper, ligula arcu tristique sapien, a accumsan nisi mauris ac eros. Curabitur turpis.</div-->

    <v-divider
      class="my-4 info"
      style="opacity: 0.22"
    />
    <!--v-row 
      v-if="!loading && (!activities || activities.length === 0)"
      align="center" 
      style="margin: 20px 0 -10px 0;"
    >
      <v-alert
        text
        outlined
        color="deep-orange"
        icon="mdi-calendar-question"
        width="100%"
      >
       {{ $t('booking.reservations.messages.noEventsForSelectedDate', locale) }}
      </v-alert>
    </v-row>
    <v-row v-else align="center" style="margin: 20px 0;">
      <v-autocomplete
        :label="$t('booking.activities.title', locale)"
        v-model="selectedActivity"
        :loading="loading"
        :items="activities"
        dense
        hide-no-data
        hide-details
        color="primary"
        item-text="name"
        item-value="id"
        @change="handleChangeActivity"
        outlined
      />
    </v-row>
    <v-row
      align="center"
      no-gutters
      v-for="event of eventsFiltered"
      :key="event.ID"
    >
      <v-col style="padding-top: 5px;">
        <v-btn
          color="primary"
          outlined
          @click="handleAddItem(event)"
          block
        >
        {{ convertTime(event.Time) }} → {{ $t('booking.reservations.addReservation', locale) }} 
        </v-btn>
      </v-col>
    </v-row-->
  </v-alert>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import utils from '@/services/utils'
export default {
  props: {
    selectedDate: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    events: [],
    eventsFiltered: [],
    activities: [],
    selectedActivity: null,
  }),
  computed: {
    ...mapState('app',['locale', 'bookingWorkspace']),
  },
  watch: {
  },
  mounted () {
    //this.handleGetEvents()
  },
  methods: {
    convertTime (v) {
      return utils.convertTime(v).split(' ').join('')
    },
    handleGetEvents () {
      this.eventsFiltered = []
      this.loading = true
      const filter = `?min=${this.selectedDate}&max=${this.selectedDate}`
      api.getAllWithoutLimit('booking', `v1/public/workspaces/${this.bookingWorkspace}/events${filter}`)
        .then(response => {
          if (response) {
            if (this.selectedDate === utils.checkDate(new Date())) 
              this.events = response.filter(x => x.AllowBook && x.Time >= ((new Date().getHours() * 60) + new Date().getMinutes()))
                                    .map(item => { 
                                      item.name = utils.getTranslation(item.ActivityName, this.locale)
                                      return item
                                    })
                                    .sort((a, b) => a.ActivityID-b.ActivityID)
            else if (new Date() > new Date(this.selectedDate)) this.events = []
            else this.events = response.sort((a, b) => a.ActivityID-b.ActivityID)
                                    .map(item => { 
                                      item.name = utils.getTranslation(item.ActivityName, this.locale)
                                      return item
                                    })
                                    .sort((a, b) => a.ActivityID-b.ActivityID)

            //TODO tmp
this.events = response.sort((a, b) => a.ActivityID-b.ActivityID)
                                    .map(item => { 
                                      item.name = utils.getTranslation(item.ActivityName, this.locale)
                                      return item
                                    })
                                    .sort((a, b) => a.ActivityID-b.ActivityID)


            //TODO tmp

            // this.events = response.sort((a, b) => a.ActivityID-b.ActivityID)
            this.activities = [...new Map(this.events.map(item => [item['ActivityID'], item])).values()].map(item => { return { id: item.ActivityID, name: item.name } })
            if (this.activities.length > 0) {
              this.selectedActivity = this.activities[0].id
              this.handleChangeActivity()
            }
          } else {
            this.events = []
            this.activities = []
          }
          this.loading = false
        })
    },
  },
}
</script>

